import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchMaradonaHandicap } from 'stores/match/index.js';
import MatchCard from 'components/general/match_card.js';
import { eventsToGroup } from 'toolkit/eventsToGroup.js';
import GoBack from 'components/general/go_back';
import { AWS_BUCKET_URL } from 'toolkit/constants';

function MaradonaHandicap() {
  const dispatch = useDispatch();
  const maradonaHandicapEvents = useSelector(
    (state) => {
      const { maradonaHandicap, events } = state.match;
      return maradonaHandicap
        .map((c) => events[c])
        .filter((match) => {
          if (!match || !match.markets) return false;
          return (
            match.markets[0].outcomes[0]?.odds !== null ||
            match.markets[0].outcomes[1]?.odds !== null ||
            match.markets[0].outcomes[2]?.odds !== null
          );
        });
    },
    (a, b) => a.length === b.length
  );
  const selectedLocale = useSelector((state) => state.match.selectedLocale);
  const locales = useSelector((state) => state.match.locales);
  const { t } = useTranslation('translations', { useSuspense: false });
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchMaradonaHandicap({ size: 0, sportType: '0' }));
  }, []);

  const groups = eventsToGroup(maradonaHandicapEvents);
  const allLeagueGroups = Object.keys(groups).reduce((acc, sportKey) => {
    return acc.concat(groups[sportKey]);
  }, []);

  return (
    <div className="container-fluid scrollable-y">
      <div
        className="overflow-auto text-nowrap bg-dark mx-n3 d-flex align-items-center px-2"
        style={{ minHeight: '36px', paddingTop: '4px', paddingBottom: '4px' }}>
        <div
          style={{
            flexShrink: 0,
            padding: '2px 4px',
            borderRadius: '4px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')}
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)')
          }>
          <div style={{ transform: 'scale(0.7)', filter: 'invert(1) brightness(2)' }}>
            <GoBack />
          </div>
        </div>
        <span className="text-white fw-bold fs-6 ms-2">
          {t('pages.start.titleMaradonaHandicap')}
        </span>
      </div>
      <div className="">
        {allLeagueGroups.length > 0 &&
          allLeagueGroups.map((leagueGroup, index) => {
            let code = null;
            if (
              leagueGroup.matches &&
              leagueGroup.matches.length > 0 &&
              leagueGroup.matches[0].categoryId
            ) {
              code = leagueGroup.matches[0].categoryId.split(':')[2];
            }
            return (
              <Fragment
                key={
                  'leaguenamesfragment' +
                  leagueGroup.category +
                  leagueGroup.league +
                  leagueGroup.matches[0].gameNumber +
                  index
                }>
                <div
                  className="text-start pb-2 fw-bold pt-1 fs-7"
                  key={
                    'leaguenames' +
                    leagueGroup.category +
                    leagueGroup.league +
                    leagueGroup.matches[0].gameNumber
                  }>
                  {code && (
                    <img
                      width="20"
                      height="13"
                      src={`${AWS_BUCKET_URL}/ClientFlags/${code}.svg`}
                      alt={code}
                      className="me-2"
                    />
                  )}
                  {leagueGroup.category + ' / ' + leagueGroup.league}
                </div>
                {leagueGroup.matches.map((match, matchIndex) => (
                  <MatchCard
                    key={match.providerId}
                    providerId={match.providerId}
                    marketType={14}
                    isMaradonaHandicap
                    index={matchIndex}
                    sport={match.sport !== undefined ? String(match.sport) : '0'}
                    path={location.pathname}
                    locales={locales}
                    selectedLocale={selectedLocale}
                  />
                ))}
              </Fragment>
            );
          })}
      </div>
    </div>
  );
}

export default MaradonaHandicap;
